// =====================================================
// WeLearn Pro Player - Chat module
// =====================================================

import Debug from './util/debugHelper';

export default class Chat {
    constructor(player) {
        this.player = player;
        this.debug = new Debug(this.player.options.debug);
    }

    getChat() {
        let self = this.player;

        $.ajax({
            url: self.options.chat.get.url,
            data: {
                cid: self.progressData.courseId,
                cb: self.progressData.courseBatchId
            },
            async: false,
            type: 'post',
            success: function (result) {
                if (self.options.debug === true) {
                    console.log("DEBUG: Chat - Chat retrieval successful");
                }

                $('.ddlchat-list').addClass('widthOpen');
                $('.overlay').addClass('active');

                $('.chat-detail').remove();
                $('li.course-head.chat-head').after(result);

                return true;
            },
            error: function () {
                if (self.options.debug === true) {
                    console.log("DEBUG: Chat - Chat retrieval failed");
                }

                return false;
            }
        });

        this.player.event._bind_chatEvent();
    }

    createQuestion(message) {
        let self = this.player;

        $.ajax({
            url: self.options.chat.insert.urlQuestion,
            data: {
                Message: message,
                cb: self.progressData.courseBatchId,
                cid: self.progressData.courseId,
            },
            async: false,
            type: 'post',
            success: function (result) {
                if (self.options.debug === true) {
                    console.log("DEBUG: Chat - Add question successful");
                }

                $.notify("สร้างหัวข้อสนทนาสำเร็จ", "success");

                $('.chat-detail').remove();
                $('li.course-head.chat-head').after(result);

                return true;
            },
            error: function () {
                if (self.options.debug === true) {
                    console.log("DEBUG: Chat - Add question failed");
                }

                $.notify("สร้างหัวข้อสนทนาไม่สำเร็จ", "error");

                return false;
            }
        });

        this.player.event._bind_chatEvent();
    }

    createAnswer(courseChatQuestionId, message) {
        let self = this.player;

        $.ajax({
            url: self.options.chat.insert.urlAnswer,
            data: {
                Message: message,
                cb: self.progressData.courseBatchId,
                CourseChatQuestionId: courseChatQuestionId
            },
            async: false,
            type: 'post',
            success: function (result) {
                if (self.options.debug === true) {
                    console.log("DEBUG: Chat - Reply successful");
                }

                $.notify("ตอบกลับสำเร็จ", "success");

                $('.chat-detail').remove();
                $('li.course-head.chat-head').after(result);

                return true;
            },
            error: function () {
                if (self.options.debug === true) {
                    console.log("DEBUG: Chat - Reply failed");
                }

                $.notify("ตอบกลับผิดพลาด", "error");

                return false;
            }
        });

        this.player.event._bind_chatEvent();
    }
}